package pl.decks.personal.extensions

import com.varabyte.kobweb.compose.css.Animation
import com.varabyte.kobweb.compose.css.BackgroundRepeat
import com.varabyte.kobweb.compose.css.BackgroundSize
import com.varabyte.kobweb.compose.css.CSSPosition
import com.varabyte.kobweb.compose.css.functions.url
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.animation
import com.varabyte.kobweb.compose.ui.modifiers.background
import com.varabyte.kobweb.compose.ui.styleModifier
import org.jetbrains.compose.web.css.px

fun Modifier.animationNotNull(vararg animations: Animation.Listable?): Modifier =
    this.animation(animations.filterNotNull())

fun Modifier.lineClamp(lines: Int): Modifier = styleModifier {
    property("display", "-webkit-box")
    property("-webkit-box-orient", "vertical")
    property("-webkit-line-clamp", lines)
    property("overflow", "hidden")
}

fun Modifier.svgBackground(
    dataUrl: String,
    scale: Pair<Double, Double>,
    repeatX: Boolean = true,
    repeatY: Boolean = true,
    position: CSSPosition = CSSPosition.Bottom,
): Modifier = this.background {
    image(url(dataUrl))
    repeat(
        horizontalRepeat = if (repeatX) BackgroundRepeat.Repeat else BackgroundRepeat.NoRepeat,
        verticalRepeat = if (repeatY) BackgroundRepeat.Repeat else BackgroundRepeat.NoRepeat,
    )
    size(BackgroundSize.of(scale.first.px, scale.second.px))
    position(position)
}
